import React, { Component } from "react";
import styles from "./Questions.module.css";
import Aux from "./../../Auxiliary/Auxiliary";
import GetQuestion from "./GetQuestion/GetQuestion";

class Questions extends Component {
  state = {
    getQuestion: false,
    answeredQuestion: false,
    correct: false,
  };

  answeredQuestionHandler = (ans) => {
    this.setState({ answeredQuestion: true, correct: ans });
  };

  toggleGetQuestionHandler = () => {
    const gQ = this.state.getQuestion;
    this.setState({ getQuestion: !gQ });
  };

  render() {
    let y = <p>Click here to answer this question</p>;
    if (this.state.answeredQuestion) {
      if (this.state.correct)
        y = (
          <p style={{ color: "green", fontSize: "1.5rem", margin: "0" }}>
            Correct
          </p>
        );
      else
        y = (
          <p style={{ color: "red", fontSize: "1.5rem", margin: "0" }}>Wrong</p>
        );
    }
    let classes = [styles.box];
    if (this.state.answeredQuestion) {
      classes.push(styles.disabled);
    }
    return (
      <Aux>
        <button
          onClick={this.toggleGetQuestionHandler}
          className={classes.join(" ")}
          disabled={this.state.answeredQuestion}
        >
          <div className={styles.qNo}>{this.props.qNo}</div>
          <div>{y}</div>
        </button>
        {this.state.getQuestion ? (
          <GetQuestion
            question={this.props.question}
            correct={this.props.correct}
            click={this.toggleGetQuestionHandler}
            score={this.props.score}
            ans={this.answeredQuestionHandler}
          />
        ) : null}
      </Aux>
    );
  }
}

export default Questions;
